// src/components/CalendarPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CalendarStyles.css'; // Custom CSS including modal styles for Big Calendar
import supabase from '../supabase'; // Ensure supabase is exported as default
import { addTestCalendarEvent } from '../utils/calendarEvents'; // Utility to insert a test event

// Setup the localizer for react-big-calendar using moment.
const localizer = momentLocalizer(moment);

const CalendarPage = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Load events from the database for the given user.
  const loadEvents = useCallback(async () => {
    const userId = 'ecd2a2fa-a084-4159-84ec-34540502d912';
    const { data, error } = await supabase
      .from('calendar_events')
      .select('*')
      .eq('user_id', userId);
      
    if (error) {
      console.error('Error fetching events:', error);
    } else if (data) {
      // Map your database events to the shape expected by react-big-calendar.
      const mappedEvents = data.map(event => ({
        id: event.id,
        title: event.title,
        start: new Date(event.event_date),
        end: event.end_date ? new Date(event.end_date) : new Date(event.event_date),
        description: event.description,
        event_type: event.event_type,
      }));
      setEvents(mappedEvents);
    }
  }, []);

  // On mount, add a test event and load events.
  useEffect(() => {
    async function initializeCalendar() {
      await addTestCalendarEvent();
      loadEvents();
    }
    initializeCalendar();
  }, [loadEvents]);

  // When an event is clicked, show its details.
  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
  };

  // Close the event details modal.
  const handleCloseModal = () => {
    setSelectedEvent(null);
  };

  return (
    <div className="calendar-page container mx-auto p-6 bg-gray-900">
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600 }}
        views={['month', 'week', 'day', 'agenda']}
        defaultView="agenda"
        onSelectEvent={handleSelectEvent}
      />
      {selectedEvent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">{selectedEvent.title}</h3>
            <p className="modal-description">{selectedEvent.description}</p>
            <p className="modal-timing">
              <strong>Start:</strong> {selectedEvent.start.toLocaleString()}<br />
              <strong>End:</strong> {selectedEvent.end.toLocaleString()}
            </p>
            <button onClick={handleCloseModal} className="modal-close-button">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarPage;
